import React from 'react'
import ModernSuspenseLoading from './components/ModernSuspenseLoading'

interface Props {}

export default function InitialLoading({}: Props) {
    return (
        <div style={{ width: '100vw', height: '100vh', background: '#f4f5f7' }}>
            <ModernSuspenseLoading />
        </div>
    )
}
